import { Skeleton } from "@mui/material";
import { Select as MUISelect } from "@mui/material";

// Rename your custom component to avoid conflict
const Select = (props) => {
  if (props.loading) {
    return (
      <Skeleton height="54px" width="100%">
        <MUISelect />
      </Skeleton>
    );
  }
  return <MUISelect {...props}>{props.children}</MUISelect>;
};

export default Select;
